import { inject, Injectable } from '@angular/core';
import {
  MessageSeverityType,
  MessageTargetType,
  MessengerService,
} from '@shared-lib/messenger';
import { AuthLogger } from './models';

@Injectable({
  providedIn: 'root',
})
export class AuthLoggerService implements AuthLogger {
  private readonly _messengerService: MessengerService =
    inject(MessengerService);

  logTrace(message: string, detailObject?: any) {
    this._messengerService.sendDetailMessage({
      severity: MessageSeverityType.Trace,
      message,
      detailObject,
      source: 'AuthService',
      targets: [MessageTargetType.Console, MessageTargetType.Log],
    });
  }

  logWarning(message: string, detailObject?: any, detailText?: string) {
    this._messengerService.sendDetailMessage({
      severity: MessageSeverityType.Warning,
      message,
      detailObject,
      detailText,
      source: 'AuthService',
      targets: [MessageTargetType.Console, MessageTargetType.Log],
    });
  }

  logError(
    message: string,
    detailObject?: any,
    detailText?: string,
    username?: string,
  ) {
    this._messengerService.sendDetailMessage({
      severity: MessageSeverityType.Error,
      message,
      detailObject,
      detailText,
      source: 'AuthService',
      targets: [MessageTargetType.Console, MessageTargetType.Log],
      username,
    });
  }
}
